import { html } from "lit";
import { customElement, query } from "lit/decorators.js";
import { ComponentId, ComponentFactory, dom, ColorTypes } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import rp, { Browser, BrowserEvent, BrowserState, BaseSidebar } from "@reporting/rp-app-host";
import { FormContainer } from "@omegagrid/form";
import { style } from "./sidebar.style";
import { TicketBrowserAdapter, FilterFormAdapter } from "../adapters";
import { HelpdeskApplication } from "..";

@customElement('rp-helpdesk-sidebar')
export class Sidebar extends BaseSidebar<HelpdeskApplication> {

	static styles = [...BaseSidebar.styles, style];

	@query('rp-browser')
	browser: Browser;

	private _browserAdapter: TicketBrowserAdapter;
    get browserAdapter() { 
        if (!this._browserAdapter) {
            this._browserAdapter = new TicketBrowserAdapter();
        }
        return this._browserAdapter;
    }

	firstUpdated() {
		this.browser.addEventListener('browser.state', this._onChangeState);
		this.browser.state = this.state?.helpdeskBrowser as BrowserState;
	}

	getState() {
		return {
			name: 'sidebar',
			helpdeskBrowser: this.browser?.getState(),
		}
	}

	_onChangeState = () => {
		this.dispatchStateEvent();
	}
	
	newTicket = () => rp.host.openModalSidebar({id: 'helpdesk-newTicketForm', caption: msg('Create new request')});
	
	openFilter() {
		const component = dom.createElement<FormContainer>('og-form-container');
		const adapter = new FilterFormAdapter(this.browserAdapter);
		component.adapter = adapter;
		component.addEventListener('form.save', () => this.browser.refresh());
		rp.host.openModalSidebar({id: 'helpdesk-filterForm', caption: msg('Filter'), component});
	}
	
	clearFilter() {
		this.browserAdapter.clearFilter();
		this.browser.refresh();
	}
	
	refresh = () => this.browser.refresh();

	toggleCollapse = () => this.browser.tree?.toggleTreeCollapse();

	openGrid () {
		rp.host.open(this.createComponentId('tickets'), {title: msg('Requests')});
	}
	_createTicketsBrowser: ComponentFactory = async (id: ComponentId) => {
		const component = dom.createElement<Browser>('rp-browser');
		const adapter = new TicketBrowserAdapter();
		component.adapter = adapter;
		return component;
	}
	
	_onSelect = (e: BrowserEvent) => {
		rp.host.open(e.node.key, {title: e.node.value});
	}
	
	layout() {}

	render = () => html`
		<div class="head">
			<og-bucket-button
				text="${msg('New request')}"
				icon="star"
				@click="${() => this.newTicket()}">
			</og-bucket-button>
		</div>
		<div class="controls">
			<og-button
				icon="search"
				color="transparent"
				text="${msg('Search')}"
				style="flex: 1"
				@click="${() => rp.host.openCommands('helpdesk')}">
			</og-button>

			<og-button
				icon="filter"
				title="${msg('Filter')}"
				color="${ColorTypes.Transparent}"
				@click="${() => this.openFilter()}">
			</og-button>

			<og-button
				icon="filter-circle-xmark"
				title="${msg('Reset filter')}"
				color="${ColorTypes.Transparent}"
				@click="${() => this.clearFilter()}">
			</og-button>

			<og-button
				icon="arrows-rotate"
				title="${msg('Refresh')}"
				color="${ColorTypes.Transparent}"
				@click="${() => this.refresh()}">
			</og-button>

			<og-button
				icon="square-plus"
				color="transparent"
				title="${msg('Collapse/Expand tree')}"
				@click="${() => this.toggleCollapse()}">
			</og-button>

			<og-button
				icon="table"
				title="${msg('Grid editor')}"
				color="${ColorTypes.Transparent}"
				@click="${() => this.openGrid()}">
			</og-button>
		</div>

		<div class="body">
			<rp-browser id="browser" .adapter="${this.browserAdapter}" @browser.select="${this._onSelect}"></rp-browser>
		</div>
	`;

}
